import React from 'react';

import { useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { observer } from 'mobx-react';

import { LbInput } from '@infoods/lifebase-ui';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import {
  HiddenInput,
  LbAutocomplete,
} from '../../../../shared/components/form-components';
import { CoachListFormValues } from '../../../interfaces/coach-list/CoachListFilters';
import { useAutoSubmitForm } from '../../../../shared/hooks/useAutoSubmitForm';
import { states } from '../../../../shared/constants/states';
import {
  COACH_LIST_COLUMN,
  CoachListMode,
  RenderRowsInfo,
  ShowRowsConfig,
} from '../NgzCoachList.settings';
import { getShowColumns } from '../utils/getShowColumns';
import { useCoachListStore } from '../hooks/useCoachListStore';

type FilterRowProps = {
  showRowsConfig: ShowRowsConfig;
  listMode: CoachListMode;
};

const FilterRow = observer(({ showRowsConfig, listMode }: FilterRowProps) => {
  const { filterMethods } = useCoachListStore(listMode);
  const { defaultFilterData, filterData, applyFilters } = filterMethods;

  const { control, register, handleSubmit, reset, watch } = useForm<CoachListFormValues>({
    defaultValues: filterData,
  });

  useAutoSubmitForm(handleSubmit(applyFilters), watch, [
    'name',
    'entityId',
    'entityCity',
  ]);

  const handleReset = () => {
    reset({ ...defaultFilterData });
  };

  const generalInputProps = { control, variant: 'outlined', size: 'small' } as const;

  const renderRowsInfo: RenderRowsInfo = {
    [COACH_LIST_COLUMN.NAME]: (
      <LbInput {...generalInputProps} name="name" placeholder="Full name" />
    ),
    [COACH_LIST_COLUMN.ENTITY]: (
      <LbInput
        {...generalInputProps}
        name="entityId"
        placeholder="Entity id"
        type="number"
      />
    ),
    [COACH_LIST_COLUMN.STATE]: (
      <LbAutocomplete
        {...generalInputProps}
        name="state"
        label="Entity state"
        options={states}
      />
    ),
    [COACH_LIST_COLUMN.CITY]: (
      <LbInput {...generalInputProps} name="entityCity" placeholder="Entity city" />
    ),
    [COACH_LIST_COLUMN.SETUP_COMMISSION]: (
      <LbInput
        {...generalInputProps}
        name="commissionSetUp"
        placeholder="Setup comsn"
        type="number"
      />
    ),
    [COACH_LIST_COLUMN.RENEW_COMMISSION]: (
      <LbInput
        {...generalInputProps}
        name="commissionRenew"
        placeholder="Renew comsn"
        type="number"
      />
    ),
    [COACH_LIST_COLUMN.COACH_DESIGNATION]: <div />,
    [COACH_LIST_COLUMN.STATUS]: <div />,
    [COACH_LIST_COLUMN.EXTRA_INFO]: (
      <GridTableCell justify="stretch">
        <Button
          variant="outlined"
          size="small"
          type="reset"
          fullWidth
          onClick={handleReset}
        >
          Clear All
        </Button>
      </GridTableCell>
    ),
  };

  const showColumns = getShowColumns(renderRowsInfo, showRowsConfig);

  return (
    <GridTableRow
      variant="filter"
      component="form"
      onSubmit={(event) => event.preventDefault()}
    >
      <HiddenInput register={register} name="withSolutionType" />
      {showColumns}
    </GridTableRow>
  );
});

export { FilterRow };
